export default "__VITE_ASSET__D$KWw3$0__$_?component__"